module.exports = __webpack_public_path__ + "img/pt-39.9293fe67.jpg";